import { useQueryParams } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function PayerFilter(props: { isLoading?: boolean }) {
  const { getParamsAsArray, setParam } = useQueryParams();
  const { t } = useTranslation();
  const paramKey = "payer";

  return (
    <Picker
      isLoading={props.isLoading}
      showActionBar
      selectedKeys={getParamsAsArray(paramKey)}
      onSelectionChange={(keys) =>
        setParam(paramKey, Array.from(keys).map(String), true)
      }
      label={t("Payer")}
      items={[
        { id: "CLIENT", name: t("Client") },
        { id: "APPLICANT", name: t("Applicant") },
      ]}
      selectionMode="multiple"
      testID="payer-filter"
    />
  );
}
